/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkin-flight-item[_ngcontent-%COMP%]{background-color:transparent;border:0;box-shadow:none}"];
export { styles as styles };
